import React from 'react';
import { useTranslation } from 'react-i18next';
import { JsonLd } from '../../JsonLd';
import { SelectedAgencyQuery } from '../../../graphql/graphql';
import { useRealEstateAgentSchema } from '../../../hooks/useRealEstateAgentSchema';

interface AgencyPageSchemaProps {
  agencyData: SelectedAgencyQuery['agency'];
}

export const AgencyPageSchema: React.FC<AgencyPageSchemaProps> = ({
  agencyData
}) => {
  const { t } = useTranslation();

  const name = t('pages.agency.title', { name: agencyData?.name });

  const itemJsonLd = useRealEstateAgentSchema(
    agencyData,
    agencyData?.contactAddress,
    name
  );

  return <JsonLd data={itemJsonLd} />;
};
